import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import state from './state'
import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const module = { state, mutations, actions, getters }

export default new Vuex.Store(module);
